import React, { useContext, useState } from "react";
import { ProductContext } from "../../../stores/session";
import request from "../../../helpers/request";
import endpoints from "../../../helpers/endpoints";

export default function usePurchase({ data, getData, getWorkflowItems, getWorkflowCounts }) {
    const { apiPrefix, isWorkflow, uuidColumn } = useContext(ProductContext)
    const [loading, setLoading] = useState(false)

    const purchaseCustomer = async (occupierPurchaseType, otherName = '') => {
        setLoading(true)
        await request(true).post(endpoints[`${apiPrefix}_BUY_CUSTOMER`], {
            "customer": data[uuidColumn],
            "occupier_purchase_type": occupierPurchaseType,
            "other_name": otherName
        }).then(res => {
            setLoading(false)
            if (isWorkflow) {
                getWorkflowItems()
                getWorkflowCounts && getWorkflowCounts()
            } else {
                getData()
            }
        }).catch(e => {
            setLoading(false)
            console.log(e);
        })
    }

    return { purchaseCustomer, loading }
}